// @flow
import React from 'react';
import { Link } from 'react-router';
import type { Recording, Track, Piece, Ad } from '../../shapes/types';

import Person from '../common/Person';
import InterpreterList from '../common/InterpreterList';
import IconLabel from '../util/IconLabel';
import TitleWithPopularTitle from '../common/TitleWithPopularTitle';
import PlayerInfoAd from './PlayerInfoAd';
import classnames from 'classnames';
import { useDesktopMediaQuery } from '../../utils/useMediaQuery';

import styles from './PlayerInfo.css';

type OwnProps = {
  recording: Recording,
  track: Track,
  piece: Piece,
  trackLink: string,
  isPlayingAd: boolean,
  currentlyPlayingAd: Ad,
};

const PlayerInfo = ({
  recording,
  track,
  piece,
  trackLink,
  isPlayingAd,
  currentlyPlayingAd,
}: OwnProps) => {
  const renderPieceTitle = (workTitle, currentPiece) => {
    if (workTitle !== currentPiece.title) {
      if (currentPiece && currentPiece.workpart) {
        const workPartTitle = currentPiece.workpart.title;
        return (
          <span>
            <span>&nbsp;&ndash;&nbsp;</span>
            {workPartTitle && <span>{`${workPartTitle} • `}</span>}
            <TitleWithPopularTitle {...currentPiece} />
          </span>
        );
      }
    }
    return null;
  };

  const isMobile = !useDesktopMediaQuery();

  if (isPlayingAd && currentlyPlayingAd) {
    return <PlayerInfoAd ad={currentlyPlayingAd} />;
  }

  if (track) {
    const { work } = recording;

    return (
      <Link className={styles.info} to={trackLink} data-test="playerbar.info-text">
        <IconLabel name="playing" size="19.2px" className={styles.iconPlaying} />
        <div
          className={classnames(styles.infoEl, {
            'sr-only': isMobile,
          })}
        >
          <Person person={work.composer} />
          <span>&nbsp;&ndash;&nbsp;</span>
          <TitleWithPopularTitle {...work} />
          {renderPieceTitle(work.title, piece)}
        </div>
        <div
          className={classnames(styles.recordingInfo, {
            'sr-only': isMobile,
          })}
        >
          <InterpreterList recording={recording} />
        </div>
      </Link>
    );
  }

  return <div className={styles.info} />;
};

export default PlayerInfo;
